/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react";
import { Link } from 'react-router-dom';
import axios from 'axios';

import HeaderTitle from "../../components/includes/HeaderTitle";
import { LoginAfterCheckLogin,isObjEmpty,ChangeMobileFormat,ChangeMobileNumber,checkEmailString } from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

const AdminInformation = ({setMenuType,setMenuItem}) => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  const admin_idx = Number(localStorage.getItem("adminIdx"));
  const [varAdminMemberInfo,setAdminMemberInfo] = useState({});

  //운영자 정보 호출하기
  const GetAdminMemberInformarion = async() => {
    const sendData = {admin_idx:admin_idx};
    console.log(sendData);
    console.log(process.env.REACT_APP_HOST);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_admin_state`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setAdminMemberInfo(datas.results);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuType('ENVIRONMENT');
    setMenuItem('AdminInformation');
    GetAdminMemberInformarion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeAdminMemberInfoHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "mem_mobile") {
      const values = ChangeMobileNumber(value);
      setAdminMemberInfo({...varAdminMemberInfo,[name]:values});
    } else if(name === "mem_email") {
      const btnBox1 = document.getElementById('dup_email');
      if(varAdminMemberInfo.chk_email === 1 || btnBox1.classList.contains('hide')) {
        if(btnBox1.classList.contains('hide')) btnBox1.classList.remove('hide');
        setAdminMemberInfo({...varAdminMemberInfo,mem_email:value,chk_email:0});
      } else {
        if(varAdminMemberInfo.old_email !== "" && varAdminMemberInfo.old_email === value) {
          if(!btnBox1.classList.contains('hide')) btnBox1.classList.add('hide');
          setAdminMemberInfo({...varAdminMemberInfo,mem_email:value,chk_email:1});
        } else {
          setAdminMemberInfo({...varAdminMemberInfo,mem_email:value});
        }
      }
    } else {
      setAdminMemberInfo({...varAdminMemberInfo,[name]:value});
    }
  }

  //운영자 정보 저장하기
  const onUpdateAdminMemberInfoHandler = async(e) => {
    if(varAdminMemberInfo.mem_email === "") {
      alert('이메일을 먼저 입력하세요.'); return false;
    } else if(!checkEmailString(varAdminMemberInfo.mem_email)) {
      setAdminMemberInfo({...varAdminMemberInfo,mem_email:""});
      alert('이메일형식에 맞지않습니다. 이메일을 다시 입력하세요.'); return false;
    } else if(varAdminMemberInfo.mem_name === "") {
      alert('관리자명을 먼저 입력하세요.'); return false;    
    } else if(varAdminMemberInfo.mem_mobile === "") {
      alert('연락처를 먼저 입력하세요.'); return false;
    } else if(varAdminMemberInfo.mem_pwd !== "") {
      if(varAdminMemberInfo.mem_pwd2 === "") {
        alert('확인을 위한 비밀번호 먼저 입력하세요.'); return false;
      } else if(varAdminMemberInfo.mem_pwd !== varAdminMemberInfo.mem_pwd2) {
        alert('새 비밀번호와 확인 비밀번호가 다릅니다. 다시 입력하세요.'); return false;
      }
    }

    if(!window.confirm('관리자 정보를 재저장합니까?')) return false;

    const sendData = {admin_idx:admin_idx,dataInfo:varAdminMemberInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_admin_state`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
    });
  }

  //중복검사
  const onDuplicationHandler = async(e) => {
    e.preventDefault();
    if(varAdminMemberInfo.mem_email === "") {
      alert('아이디(이메일)을 먼저 입력하세요.'); return false;
    } 
    if(!checkEmailString(varAdminMemberInfo.mem_email)) {
      alert('아이디(이메일)의 입력값이 이메일 형식에 맞지 않습니다. 확인후 재입력하세요.');
      return false;
    }
    const sendData = {fieldName:'mem_email',fieldValue:varAdminMemberInfo.mem_email};
    await axios.post(`${process.env.REACT_APP_HOST}/_check_duplicate_name`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        setAdminMemberInfo({...varAdminMemberInfo,chk_email:1});
      }
      alert(datas.message);
    });
  }

  return isObjEmpty(varAdminMemberInfo)?null:(
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="설정관리" varPageTitle="관리자 정보 관리" />
      <div className="admin-content">
        <div className="main-box">
          <table cellPadding="5" cellSpacing="0" border="1" className="write" style={{borderCollapse: "collapse"}}>
            <colgroup><col width="30%"/><col width="70%"/></colgroup>
            <thead></thead>
            <tbody>
              <tr>
                <th>아이디</th>
                <td>{varAdminMemberInfo.mem_id}</td>
              </tr>
              <tr>
                <th>이름</th>
                <td><input type="text" className="w_s_input" name="mem_name" value={varAdminMemberInfo.mem_name} onChange={(e)=>onChangeAdminMemberInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>연락처</th>
                <td><input type="text" className="w_s_input" style={{width:"50%"}} name="mem_mobile" value={ChangeMobileFormat(varAdminMemberInfo.mem_mobile)||""} onChange={(e)=>onChangeAdminMemberInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>이메일</th>
                <td>
                  <input type="text" className="w_s_input" style={{width:"70%"}} name="mem_email" value={varAdminMemberInfo.mem_email||""} onChange={(e)=>onChangeAdminMemberInfoHandler(e)}/>
                  <button  className={varAdminMemberInfo.chk_email===0?"btn":"btn gray"} id="dup_email" onClick={e=>onDuplicationHandler(e)}>중복확인</button>
                </td>
              </tr>
              <tr>
                <th>새 비밀번호</th>
                <td><input type="password" className="w_s_input" name="mem_pwd" style={{width:"40%"}} value={varAdminMemberInfo.mem_pwd||""} onChange={(e)=>onChangeAdminMemberInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>새 비밀번호 확인</th>
                <td><input type="password" className="w_s_input" name="mem_pwd2" style={{width:"40%"}} value={varAdminMemberInfo.mem_pwd2||""} onChange={(e)=>onChangeAdminMemberInfoHandler(e)}/></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="btn-center" style={{marginBottom:"20px"}}>
          <Link to={`/MainAdmin`} style={{width:"90px"}} className="btn line">메인화면</Link>
          <button onClick={(e)=>onUpdateAdminMemberInfoHandler(e)} style={{width:"90px"}} className="btn line">저장</button>
        </div>
      </div>
    </div>
  );
}
export default AdminInformation;